import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeriesPoint } from './op-chart-series-point'
import { OpDescr } from '../core/op-descr'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpFile } from '../core/op-file'


export class OpSchemaElementApperance {
    //Properties
    public color: string
    public colorCode: string
    public image: number[] | string
    public physicalFileName: string
    public condition: string
    public constraint1: any
    public constraint2: any
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.color = Utils.getHexColorFromSystemDrawingColor(opObj.Color)
            this.colorCode = opObj.ColorCode
            this.image = opObj.Image
            this.physicalFileName = opObj.PhysicalFileName
            this.condition = opObj.Condition
            this.constraint1 = opObj.Constraint1
            this.constraint2 = opObj.Constraint2
        }
    }
}